import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@apollo/client/react';
import { FormattedMessage } from 'react-intl';
import { DashboardLink } from 'utils/link';
import { useError } from 'contexts/error';
import { PaginateProvider } from 'contexts/paginate';
import { Box } from 'components/ui';
import { WhiteCard } from 'components/styles_components/card';
import { BreadCrumbTypography } from 'components/styles_components/typography';
import SpaceQuery from 'queries/space/show';
import ShowItem from 'components/space/show_item';
import UsersIndexContainer from 'components/space_users/index_container';
import Plan from 'components/space/plan';
import Orders from 'components/space/order/index_container';
import BreadcrumbContainer from 'components/layout/breadcrumb_container';
import TabsContainer from 'components/layout/tabs_container';
import TopMenu from 'components/layout/top_menu';
import LoaderContainer from 'components/layout/loader_container';
import Container from 'components/layout/container';

const Space = () => {
  const navigate = useNavigate();
  const setError = useError();
  const {
    data = {
      space: {
        id: null,
        name: '',
        adminRole: false,
      },
      initLoading: true,
    },
    loading,
    error,
    refetch,
  } = useQuery(SpaceQuery, {
    cachePolicy: 'cache-and-network',
    onError: () => {
      setError('error.space.show');
      navigate(DashboardLink());
    },
  });

  return (
    <Container>
      <TopMenu>
        <BreadcrumbContainer>
          <BreadCrumbTypography>
            <FormattedMessage id="breadcrumb.space.show" />
          </BreadCrumbTypography>
        </BreadcrumbContainer>
      </TopMenu>
      <LoaderContainer
        loading={loading}
        error={error}
        wrap={false}
        keepRenderedContent={!data.initLoading}
      >
        <ShowItem space={data.space} refetch={refetch} />
      </LoaderContainer>
      <Box sx={{ mt: 2 }}>
          <WhiteCard>
            <TabsContainer
              tabs={[
                { key: 'users', label: <FormattedMessage id="navbar.users" />, visible: true },
                { key: 'billing', label: <FormattedMessage id="navbar.billing" />, visible: true },
              ]}
              content={[
                <PaginateProvider key="space_users_content">
                  <UsersIndexContainer />
                </PaginateProvider>,
                <Box key="space_billing_content">
                  <Plan />
                  <Box sx={{ mt: 2 }}>
                    <PaginateProvider>
                      <Orders />
                    </PaginateProvider>
                  </Box>
                </Box>,
              ]}
            />
          </WhiteCard>
      </Box>
    </Container>
  );
};

export default Space;
